import axios  from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const ordersList = async (token) => {
  try {
    const confiq = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await apiService.get("/my-order-list", confiq);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const orderDetails = async (token, orderId) => {
  try {
    const confiq = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await apiService.get(
      `/my-order-detail/${orderId}`,
      confiq
    );
    return response.data;
  } catch (error) {}
};
export const getmyOrderEmailDetails = async (orderCode, email) => {
  try {
   
    const response = await apiService.get(`/order-view/${email}/${orderCode}`);
    return response.data;
  } catch (error) {}
};

export const cancelOrderApi =async(orderCode, token)=>{
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    const payload = {
      order_code: orderCode,
    }
    const response = await apiService.post('/my-order-cancel',payload, config)
    return response.data;
  } catch (error) {
    
  }
}
export const orderReturnRequest = async(payload, token)=>{
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    const body = {
      order_code: payload,
    }
    const response = await apiService.post('/order-return-request', body , config)
    return response.data
  } catch (error) {
    
  }
}
export const placeOrderCreate = async (payload,token) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await apiService.post("/place-order", payload, config);
    return response.data;
  } catch (error) {
    console.error("Order cannot be placed :( ");
  }
};